import { AppBar, Toolbar } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SplitButton,
	SubmitButton,
} from "@websential/cosmic-v20";

import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";

// import { SplitButton } from "./SplitButton";

export interface IOffCyclePayrollSetupToolbar {
	offCyclePayrollScreenPermissions: any;
	onSubmitButtonClickedHandler: () => void;
	onCalculateOffCyclePayrollClicked: () => void;
	onInsertButtonClicked: (selectedItem: any) => void;
	onDeleteEmployeeOffCyclePayrollDataClicked: () => void;
	haveCalculatedTable: boolean;
	offCyclePayrollTableData: any;
}

export const OffCyclePayrollSetupToolbar: FC<IOffCyclePayrollSetupToolbar> = ({
	onSubmitButtonClickedHandler,
	onCalculateOffCyclePayrollClicked,
	onInsertButtonClicked,
	onDeleteEmployeeOffCyclePayrollDataClicked,
	haveCalculatedTable,
	offCyclePayrollTableData,
	offCyclePayrollScreenPermissions
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				// // marginTop: theme.spacing(3),
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
				// position: "sticky",
				// bottom: 0,
				// top: 'auto',
				// bottom: 0,
				// backgroundColor: '#fff',
				// boxShadow: 'none',
				// alignItems: 'center',
				// zIndex: (theme) => theme.zIndex.drawer + 1, // ensure above other elements

				paddingBottom: haveCalculatedTable ? "5rem" : ""
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					label="Save"
					// type="submit"
					onClickHandler={onSubmitButtonClickedHandler}
					// icon="pi pi-check"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				{/* <SplitButton
					options={["Insert Gross Hours", "Insert Gross", "Insert Hours", "Insert Previous", "Insert EDR"]}
					onClickHandler={onInsertButtonClicked}
					testId="t4-print-button"
				// icon={"pi pi-sign-in"}
				// listItemsLabel={`Print T4 Slips `}

				/> */}
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Insert Gross"
					raised
					onClickHandler={() => onInsertButtonClicked('Insert Gross')}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteEmployeeOffCyclePayrollDataClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
				{/* {offCyclePayrollScreenPermissions && offCyclePayrollScreenPermissions["Calculate Payroll"] && offCyclePayrollScreenPermissions["Calculate Payroll"] ? */}<EnhancedButtonPrimeReact
					// icon="pi pi-plus"
					label="Calculate Payroll"
					raised
					onClickHandler={onCalculateOffCyclePayrollClicked}
					style={{ marginLeft: "1rem" }}
				// severity={EnhancedButtonPrimeReactSeverity.Secondary}
				// disabled={offCyclePayrollTableData.items.some((item: any) => item.salaryProfileMessage && item.salaryProfileMessage !== null)}
				/> {/* : <></>} */}
			</Toolbar>
		</AppBar>
	);
};
